module.exports = __webpack_public_path__ + "static/media/MaisonNeue-Demi.6673fe55.otf";